import { FC } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import useCollaboration from "./../../hooks/useCollaboration";
import { useMedia } from "./../../hooks/useMedia";
import useShallowSelector from "./../../hooks/useShalowSelector";
import { useUser } from "./../../hooks/useUser";
import { selectStylesBackground } from "./../../store/forms/selectors";
import { IForm } from "./../../store/forms/types";
import { selectLogicPopup } from "./../../store/ui/selectors";
import Collaborators from "./../Collaborators";
import Content from "./../Content";
import Header from "./../Header";
import ModeBar from "./../ModeBar";
import Pages from "./../Pages";
import Popup from "./../Popup/index";
import Settings from "./../Settings";
import SideBar from "./../SideBar";
import LogicPopup from "./../SideBar/Logic/LogicPopup";
import UserOptions from "./../UserOptions";
import { getFormBackgroundStyles } from "./helpers/getFormBackgroundStyles";

import styles from "./styles.module.scss";

interface IProps {
    form: IForm;
}

const Layout: FC<IProps> = ({ form }) => {
    const { isOpen: isCollaboratorsOpen, onToggle: onCollaborationToggle } = useCollaboration();
    const { isOpen: isUserOptionsOpen, onToggle: onUserOptionsToggle } = useUser();
    const formBackgroundStyles = useShallowSelector(selectStylesBackground);
    const { isOpen: isLogicPopupOpen } = useShallowSelector(selectLogicPopup);
    const { type: screenType } = useMedia();

    return (
        <>
            <DndProvider backend={HTML5Backend}>
                <div className={styles.layout} style={getFormBackgroundStyles(formBackgroundStyles)} id={"blurable"}>
                    <div id="toolbarContainer"></div>
                    <div id="tooltipContainer"></div>
                    <Header name={form.name} />
                    <ModeBar />
                    <Pages />
                    <SideBar />
                    <Content screenType={screenType} />
                    {isCollaboratorsOpen && <Collaborators onClose={onCollaborationToggle} />}
                    {isUserOptionsOpen && <UserOptions onClose={onUserOptionsToggle} />}
                </div>
            </DndProvider>
            <Settings />
            <Popup />
            {isLogicPopupOpen && <LogicPopup />}
        </>
    );
};

export default Layout;
